/**
 * components.js
 *
 * Import the JS for your components here.
 *
 */

import './mobile-header/primary-links/c-primary-links';
import './mobile-header/mobile-nav-trigger/c-mobile-nav-trigger';
import './mobile-header/mobile-search-trigger/c-mobile-search-trigger';
import './mobile-header/mobile-search/c-mobile-search';
import './back-to-top/c-back-to-top';
import './accordion/c-accordion';
import './print-social-share/c-print-social-share';
import './search-bar/c-search-bar';
import './slider/c-slider';
import './modal/c-modal';
import './filtered-listing/c-filtered-listing';
import './form-elements/datepicker/c-datepicker';
// import './form-elements/file-uploader/c-file-uploader';
import './tab/c-tabs';
import './tooltip/c-tooltip';
// import './newsletter-signup-form/c-newsletter-signup-form';
import './tab/c-tab-listing';
import './lazyload/lazyload';
import './toggle-theme/toggle-theme';
import './stat/c-stat';
import './cta-banner/c-cta-banner';
import './quote/c-quote';
import './chatbot/c-chatbot';
import './typeform-tracker/c-typeform-tracker';
import './form-tracker/c-form-tracker';

// React components
import ComponentInit from '../js/utils/ComponentInit';
import SitecoreSearchBar from './search-bar-sitecore/c-search-bar-sitecore';
import MobileSearchSitecore from './mobile-header/mobile-search-sitecore/c-mobile-search-sitecore';
import SideQuickLinks from './side-quick-links/c-side-quick-links';

const componentList = { SitecoreSearchBar, MobileSearchSitecore, SideQuickLinks };

export default ComponentInit(componentList);
